import {EventType} from 'src/openapi/models/EventType';
import {SystemEventSource} from 'src/openapi/models/SystemEventSource';
import {UserEventSource} from 'src/openapi/models/UserEventSource';

const EVENT_TYPE_SOURCE_MAP = {
    [EventType.USER_EVENT]: Object.values(UserEventSource).sort(),
    [EventType.SYSTEM_EVENT]: Object.values(SystemEventSource).sort(),
};

export const getSourcesByEventType =
    (eventType: EventType): string[] => EVENT_TYPE_SOURCE_MAP[eventType] ?? [];
